import { getV4EditorRoute } from 'FormsUI/lib/RouteGenerators';
import { getWindowLocation, getWindowLocationSearch } from '../../../utils/WindowGetters';
import { navigateTo } from 'FormsUI/utils/UrlUtils';
export const appendCurrentQueryParamsToUrl = url => {
  const currentParams = new URLSearchParams(getWindowLocationSearch());
  currentParams.forEach((value, key) => {
    url.searchParams.set(key, value);
  });
};
const redirectToNewEditor = (id, creationType) => {
  const location = getWindowLocation();
  const newEditorUrl = new URL(getV4EditorRoute(id, creationType), location.origin);
  appendCurrentQueryParamsToUrl(newEditorUrl);
  navigateTo(newEditorUrl.toString());
};
export default redirectToNewEditor;